import React from 'react';
import { colors } from '@guryou/colors';

const AnimatedBackground = ({ children, className = '' }) => {
  return (
    <div className={`relative overflow-hidden ${className}`} style={{ backgroundColor: colors.mineShaft }}>
      {/* Animated Grid Pattern */}
      <div className="absolute inset-0 opacity-20">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `
            linear-gradient(color-mix(in srgb, var(--feel-primary) 25%, transparent) 1px, transparent 1px),
            linear-gradient(90deg, color-mix(in srgb, var(--feel-primary) 25%, transparent) 1px, transparent 1px)
          `,
            backgroundSize: '50px 50px',
            animation: 'gridMove 20s linear infinite',
          }}
        ></div>
      </div>

      {/* Geometric Shapes */}
      <div className="absolute inset-0">
        {/* Large Triangle */}
        <div
          className="absolute top-0 right-0 w-0 h-0 opacity-30"
          style={{
            borderLeft: '300px solid transparent',
            borderTop: '300px solid color-mix(in srgb, var(--feel-primary) 25%, transparent)',
            animation: 'float 6s ease-in-out infinite',
          }}
        ></div>

        {/* Medium Circle */}
        <div
          className="absolute bottom-0 left-0 w-64 h-64 rounded-full opacity-25"
          style={{
            backgroundColor: 'var(--feel-primary-dark)',
            filter: 'blur(60px)',
            animation: 'pulse 4s ease-in-out infinite',
          }}
        ></div>

        {/* Small Hexagon */}
        <div
          className="absolute top-1/3 right-1/3 w-32 h-32 opacity-20"
          style={{
            backgroundColor: 'var(--feel-primary)',
            clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)',
          }}
        ></div>

        {/* Static Dots */}
        <div
          className="absolute top-1/4 left-1/4 w-4 h-4 rounded-full opacity-40"
          style={{
            backgroundColor: 'var(--feel-primary-dark)',
          }}
        ></div>
        <div
          className="absolute top-3/4 right-1/4 w-6 h-6 rounded-full opacity-30"
          style={{
            backgroundColor: 'var(--feel-primary)',
          }}
        ></div>
        <div
          className="absolute top-1/2 left-1/2 w-3 h-3 rounded-full opacity-50"
          style={{
            backgroundColor: 'var(--feel-primary-dark)',
          }}
        ></div>
        <div
          className="absolute top-1/6 right-1/6 w-2 h-2 rounded-full opacity-60"
          style={{
            backgroundColor: 'var(--feel-primary)',
          }}
        ></div>
        <div
          className="absolute bottom-1/3 left-1/3 w-5 h-5 rounded-full opacity-35"
          style={{
            backgroundColor: 'var(--feel-primary-dark)',
          }}
        ></div>
      </div>

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes gridMove {
          0% {
            transform: translate(0, 0);
          }
          100% {
            transform: translate(50px, 50px);
          }
        }
        @keyframes float {
          0%,
          100% {
            transform: translateY(0px) rotate(0deg);
          }
          50% {
            transform: translateY(-20px) rotate(5deg);
          }
        }
        @keyframes pulse {
          0%,
          100% {
            transform: scale(1);
            opacity: 0.25;
          }
          50% {
            transform: scale(1.1);
            opacity: 0.4;
          }
        }
      `}</style>

      {/* Content */}
      <div className="relative z-10">{children}</div>
    </div>
  );
};

export default AnimatedBackground;
